import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

interface IProps {
    className?: string;
    style?: any;
}

export const Image: React.FunctionComponent<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 64 64" {...props}>
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g>
                    <rect fillRule="nonzero" x="0" y="0" width="64" height="64"></rect>
                    <circle stroke="currentColor" strokeWidth="3" cx="48" cy="16" r="8"></circle>
                    <polygon
                        stroke="currentColor"
                        strokeWidth="3"
                        strokeLinejoin="round"
                        points="8 53.3333333 24 24 34.6666667 42.6666667 45.3333333 37.3333333 56 53.3333333"
                    ></polygon>
                </g>
            </g>
        </SvgIcon>
    );
};
